import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonSlash32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPersonSlash32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.382 9.362A5.502 5.502 0 0 0 10.5 10.5c0 1.694.766 3.21 1.97 4.218A9 9 0 0 0 7 23v.744l2.139-2.139a7.01 7.01 0 0 1 5.466-5.466l2.242-2.242a3.5 3.5 0 1 1 2.55-2.55zm-1.905 7.561L11.4 25H23v-2c0-2.6-1.418-4.87-3.523-6.077M9.4 27l-1.693 1.693a1 1 0 0 1-1.414-1.414L24.879 8.693a1 1 0 1 1 1.414 1.415L20.93 15.47A8.99 8.99 0 0 1 25 23v4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonSlash32);
